export const InhibitRestartStatus = {
  RestartEnabled: 'RestartEnabled',
  RestartDisabled: 'RestartDisabled',
  Enabled: 'enabled',
  Disabled: 'disabled',
};

export interface IInhibitRestartMetadata {
  hasPendingCommand: boolean;
  isEnabled: boolean;
  isEnableing: boolean;
  commandStatusToSend?: string;
  isLocallyDisabled: boolean;
}
